import moment from 'moment';
export const BASEURL = "https://api.boukanagahi.ir/api";
export function fromNow(date, nowDate = Date.now()) {
    const SECOND = 1000;
    const MINUTE = 60 * SECOND;
    const HOUR = 60 * MINUTE;
    const DAY = 24 * HOUR;
    const WEEK = 7 * DAY;
    const MONTH = 30 * DAY;
    const YEAR = 365 * DAY;
    const intervals = [
        { ge: YEAR, divisor: YEAR, unit: "year", label: ' سال پیش ' },
        { ge: MONTH, divisor: MONTH, unit: "month", label: ' ماه پیش ' },
        { ge: WEEK, divisor: WEEK, unit: "week", label: ' هفته پیش ' },
        { ge: DAY, divisor: DAY, unit: "day", label: ' روز پیش ' },
        { ge: HOUR, divisor: HOUR, unit: "hour", label: ' ساعت پیش ' },
        { ge: MINUTE, divisor: MINUTE, unit: "minute", label: ' دقیقه پیش ' },
        { ge: 30 * SECOND, divisor: SECOND, unit: "seconds", label: ' ثانیه پیش ' },
        { ge: 0, divisor: 1, text: 'همین الان' },
    ];
    const now = typeof nowDate === 'object' ? nowDate.getTime() : new Date(nowDate).getTime();
    const diff = now - (typeof date === 'object' ? date : new Date(date)).getTime();
    const diffAbs = Math.abs(diff);
    for (const interval of intervals) {
        if (diffAbs >= interval.ge) {
            const x = Math.round(Math.abs(diff) / interval.divisor);

            return interval.unit ? x + interval.label : interval.text;
        }
    }
}

export function get_url_extension(url) {
    let exp = url.split(/[#?]/)[0].split('.').pop().trim();
    let type = 'file';
    if (exp == 'png' || exp == 'jpg' || exp == 'jpeg') {
        type = 'image';
    }
    return [exp, type]
}
function groupedDays(messages) {
    return messages.reduce((acc, el, i) => {
        const messageDay = moment(el.created_at).format('YYYY-MM-DD');
        if (acc[messageDay]) {
            return { ...acc, [messageDay]: acc[messageDay].concat([el]) };
        }
        return { ...acc, [messageDay]: [el] };
    }, {});
}

export function generateItems(messages) {
    const days = groupedDays(messages);
  
    const sortedDays = Object.keys(days).sort(
        (x, y) => moment(x, 'YYYY-MM-DD').unix() - moment(y, 'YYYY-MM-DD').unix()
    );
    const items = sortedDays.reduce((acc, date) => {
        const sortedMessages = days[date].sort(
            (x, y) => new Date(x.created_at) - new Date(y.created_at)
        );
        return acc.concat([{ type: 'day', date, id: date }, ...sortedMessages]);
    }, []);
    return items;
}

export const addDay = (date, days, local) => {
    date = new Date(date)

    date.setDate(date.getDate() + days);

    return date.toLocaleDateString(local);
}

export const agoDay = (date) => {
    date = new Date(date)
    let now = new Date();
    if (date.getTime() < now.getTime()) {
        return 0;
    }
    date = date.getTime() - now.getTime();
    date = ((((date / 1000) / 60) / 60) / 24).toFixed();
    return date;
}


export const fileToDataUri = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
        resolve(event.target.result)
    };
    reader.readAsDataURL(file);
})